import { render, staticRenderFns } from "./scGiveFormTrial.vue?vue&type=template&id=6860e754&scoped=true&"
import script from "./scGiveFormTrial.vue?vue&type=script&lang=js&"
export * from "./scGiveFormTrial.vue?vue&type=script&lang=js&"
import style0 from "./scGiveFormTrial.vue?vue&type=style&index=0&id=6860e754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6860e754",
  null
  
)

export default component.exports